// Vollea — Password input with show/hide eye toggle.
// Keeps the same visual shape as the plain inputs on Login/Register (52px
// tall, surface bg, lime focus) and exposes the same `style` knobs so it
// drops in where a bare <input type="password" /> used to live.
import React, { useState } from "react";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { C, SP, R } from "../lib/theme";

export default function PasswordInput({
  value,
  onChange,
  placeholder,
  minLength,
  required,
  autoComplete = "current-password",
  testid,
  toggleTestid,
  style,
}) {
  const [reveal, setReveal] = useState(false);

  const wrap = {
    width: "100%", background: C.surface, borderRadius: R.md,
    border: `1px solid ${C.border}`, height: 52,
    display: "flex", alignItems: "center", padding: `0 ${SP.md}px 0 ${SP.lg}px`,
    ...style,
  };
  const input = {
    flex: 1, background: "transparent", border: "none", outline: "none",
    color: C.text, fontSize: 15, height: "100%", padding: 0,
    fontFamily: "inherit",
  };
  const btn = {
    width: 36, height: 36, borderRadius: R.sm, background: "transparent",
    border: "none", color: C.textMuted, cursor: "pointer",
    display: "inline-flex", alignItems: "center", justifyContent: "center",
  };

  return (
    <div style={wrap}>
      <input
        data-testid={testid}
        type={reveal ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder || "••••••••"}
        minLength={minLength}
        required={required}
        autoComplete={autoComplete}
        style={input}
      />
      <button
        type="button"
        onClick={() => setReveal((r) => !r)}
        aria-label={reveal ? "Hide password" : "Show password"}
        aria-pressed={reveal}
        data-testid={toggleTestid}
        style={btn}
      >
        {reveal ? <IoEyeOff size={20} /> : <IoEye size={20} />}
      </button>
    </div>
  );
}
